var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 1.75H1.5625C0.7 1.75 0 2.45 0 3.3125V12.6875C0 13.55 0.7 14.25 1.5625 14.25H14.4375C15.3 14.25 16 13.55 16 12.6875V3.3125C16 2.45 15.3 1.75 14.4375 1.75ZM4.9625 4.45312C5.91875 4.45312 6.69375 5.22812 6.69375 6.18437C6.69375 7.14062 5.91875 7.91563 4.9625 7.91563C4.00625 7.91563 3.23125 7.14062 3.23125 6.18437C3.23125 5.22812 4.00625 4.45312 4.9625 4.45312ZM7.225 11.5469H2.70312C2.06875 11.5469 1.61563 10.9281 1.80938 10.325L2.32812 8.70938C2.47187 8.26563 2.96875 8.04063 3.39375 8.2375C3.775 8.4125 4.29688 8.56563 4.9625 8.56563C5.62813 8.56563 6.15312 8.4125 6.53125 8.2375C6.95625 8.04375 7.45625 8.26563 7.59688 8.70938L8.11563 10.325C8.3125 10.9281 7.85938 11.5469 7.225 11.5469ZM13.7812 9.46875H10.2812C10.0406 9.46875 9.84375 9.27187 9.84375 9.03125C9.84375 8.79063 10.0406 8.59375 10.2812 8.59375H13.7812C14.0219 8.59375 14.2188 8.79063 14.2188 9.03125C14.2188 9.27187 14.025 9.46875 13.7812 9.46875ZM13.7812 7.90625H10.2812C10.0406 7.90625 9.84375 7.70937 9.84375 7.46875C9.84375 7.22813 10.0406 7.03125 10.2812 7.03125H13.7812C14.0219 7.03125 14.2188 7.22813 14.2188 7.46875C14.2188 7.70937 14.025 7.90625 13.7812 7.90625ZM13.7812 6.34375H10.2812C10.0406 6.34375 9.84375 6.14687 9.84375 5.90625C9.84375 5.66563 10.0406 5.46875 10.2812 5.46875H13.7812C14.0219 5.46875 14.2188 5.66563 14.2188 5.90625C14.2188 6.14687 14.025 6.34375 13.7812 6.34375Z",
    fill: "url(#paint0_linear_209_504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_504",
    x1: 1.33269,
    y1: 1.33269,
    x2: 14.6673,
    y2: 14.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissions);
export default __webpack_public_path__ + "static/media/Admissions.ef58e9ba86c7222caf8ca9a87841cd9d.svg";
export { ForwardRef as ReactComponent };